module.exports = __webpack_public_path__ + "static/media/visa.12c59f1a.png";